const indexItems = [
  { title: '国产电视剧', icon: 'ri-tv-line', desc: '热播剧、经典剧、最新上线', color: 'primary' },
  { title: '院线电影', icon: 'ri-film-line', desc: '2026 最新大片高清看', color: 'accent' },
  { title: '热门综艺', icon: 'ri-mic-line', desc: '搞笑、音乐、真人秀', color: 'secondary' },
  { title: '动漫番剧', icon: 'ri-ghost-line', desc: '日漫国漫全收录', color: 'primary' },
  { title: '韩剧专区', icon: 'ri-heart-pulse-line', desc: '最新韩剧同步更新', color: 'accent' },
  { title: '美剧英剧', icon: 'ri-global-line', desc: '高分海外剧集精选', color: 'secondary' },
  { title: '纪录片', icon: 'ri-compass-3-line', desc: '自然历史人文探索', color: 'primary' },
  { title: '港台影视', icon: 'ri-building-line', desc: '经典港片台剧重温', color: 'accent' },
  { title: '短剧合集', icon: 'ri-smartphone-line', desc: '精彩短剧刷不停', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; icon: string; badge: string }> = {
  primary: { bg: 'bg-primary-100', icon: 'text-primary-500', badge: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', icon: 'text-accent-500', badge: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-500', badge: 'bg-secondary-500' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            影视分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按类型快速找到你想看的内容，总有一类适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, idx) => {
            const c = colorMap[item.color];
            return (
              <a
                key={idx}
                href="#cards"
                className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/50 transition-all duration-200 cursor-pointer no-underline group"
              >
                <div className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${c.bg} flex-shrink-0`}>
                  <i className={`${item.icon} ${c.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                    {item.desc}
                  </p>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}